import InvoiceTable from "../../../components/selfcare/InvoiceTable";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import SelfcarePageContent from "../../../components/selfcare/SelfcarePageContent";
import {useSearchParams} from "react-router-dom";
import Icon from "../../../components/selfcare/Icon";
import IconOpenInNew from "../../../components/icons/IconOpenInNew.tsx";
import IconDownload from "../../../components/icons/IconDownload.tsx";

export default function OverviewPage() {
    const {customer} = useCustomer()
    const [searchParams] = useSearchParams()

    return <SelfcarePageContent>
        <div className="selfcare-page-summary">
            <h1 className="heading heading--big">Regninger</h1>
            <p>
                Her kan du se alle dine regninger.<br/>
                Tryk <Icon component={IconOpenInNew}/> for at åbne en regning i en ny fane eller <Icon component={IconDownload}/> for at downloade den.
            </p>
        </div>

        <InvoiceTable customer_id={customer.customer_id} page={Number(searchParams.get('page') ?? 1)}/>
    </SelfcarePageContent>
}
